"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _IconAnchorUnits = _interopRequireDefault(require("./IconAnchorUnits.js"));

var _IconOrigin = _interopRequireDefault(require("./IconOrigin.js"));

var _ImageState = _interopRequireDefault(require("../ImageState.js"));

var _Image = _interopRequireDefault(require("./Image.js"));

var _color = require("../color.js");

var _asserts = require("../asserts.js");

var _IconImage = require("./IconImage.js");

var _util = require("../util.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/style/Icon
 */


/**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {import("./IconOrigin.js").default} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("./IconAnchorUnits.js").default} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {import("./IconAnchorUnits.js").default} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {HTMLImageElement|HTMLCanvasElement} [img] Image object for the icon. If the `src` option is not provided then the
 * provided image must already be loaded. And in that case, it is required
 * to provide the size of the image, with the `imgSize` option.
 * @property {Array<number>} [offset=[0, 0]] Offset, which, together with the size and the offset origin, define the
 * sub-rectangle to use from the original icon image.
 * @property {Array<number>} [displacement=[0,0]] Displacement of the icon.
 * @property {import("./IconOrigin.js").default} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {import("../size.js").Size} [size] Icon size in pixel. Can be used together with `offset` to define the
 * sub-rectangle to use from the origin (sprite) icon image.
 * @property {import("../size.js").Size} [imgSize] Image size in pixels. Only required if `img` is set and `src` is not, and
 * for SVG images in Internet Explorer 11. The provided `imgSize` needs to match the actual size of the image.
 * @property {string} [src] Image source URI.
 */

/**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */
var Icon =
/** @class */
function (_super) {
  __extends(Icon, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function Icon(opt_options) {
    var _this = this;

    var options = opt_options || {};
    /**
     * @type {number}
     */

    var opacity = options.opacity !== undefined ? options.opacity : 1;
    /**
     * @type {number}
     */

    var rotation = options.rotation !== undefined ? options.rotation : 0;
    /**
     * @type {number|import("../size.js").Size}
     */

    var scale = options.scale !== undefined ? options.scale : 1;
    /**
     * @type {boolean}
     */

    var rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
    _this = _super.call(this, {
      opacity: opacity,
      rotation: rotation,
      scale: scale,
      displacement: options.displacement !== undefined ? options.displacement : [0, 0],
      rotateWithView: rotateWithView
    }) || this;
    /**
     * @private
     * @type {Array<number>}
     */

    _this.anchor_ = options.anchor !== undefined ? options.anchor : [0.5, 0.5];
    /**
     * @private
     * @type {Array<number>}
     */

    _this.normalizedAnchor_ = null;
    /**
     * @private
     * @type {import("./IconOrigin.js").default}
     */

    _this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : _IconOrigin["default"].TOP_LEFT;
    /**
     * @private
     * @type {import("./IconAnchorUnits.js").default}
     */

    _this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : _IconAnchorUnits["default"].FRACTION;
    /**
     * @private
     * @type {import("./IconAnchorUnits.js").default}
     */

    _this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : _IconAnchorUnits["default"].FRACTION;
    /**
     * @private
     * @type {?string}
     */

    _this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
    /**
     * @type {HTMLImageElement|HTMLCanvasElement}
     */

    var image = options.img !== undefined ? options.img : null;
    /**
     * @private
     * @type {import("../size.js").Size|undefined}
     */

    _this.imgSize_ = options.imgSize;
    /**
     * @type {string|undefined}
     */

    var src = options.src;
    (0, _asserts.assert)(!(src !== undefined && image), 4); // `image` and `src` cannot be provided at the same time

    (0, _asserts.assert)(!image || image && _this.imgSize_, 5); // `imgSize` must be set when `image` is provided

    if ((src === undefined || src.length === 0) && image) {
      src =
      /** @type {HTMLImageElement} */
      image.src || (0, _util.getUid)(image);
    }

    (0, _asserts.assert)(src !== undefined && src.length > 0, 6); // A defined and non-empty `src` or `image` must be provided

    /**
     * @type {import("../ImageState.js").default}
     */

    var imageState = options.src !== undefined ? _ImageState["default"].IDLE : _ImageState["default"].LOADED;
    /**
     * @private
     * @type {import("../color.js").Color}
     */

    _this.color_ = options.color !== undefined ? (0, _color.asArray)(options.color) : null;
    /**
     * @private
     * @type {import("./IconImage.js").default}
     */

    _this.iconImage_ = (0, _IconImage.get)(image,
    /** @type {string} */
    src, _this.imgSize_ !== undefined ? _this.imgSize_ : null, _this.crossOrigin_, imageState, _this.color_);
    /**
     * @private
     * @type {Array<number>}
     */

    _this.offset_ = options.offset !== undefined ? options.offset : [0, 0];
    /**
     * @private
     * @type {import("./IconOrigin.js").default}
     */

    _this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : _IconOrigin["default"].TOP_LEFT;
    /**
     * @private
     * @type {Array<number>}
     */

    _this.origin_ = null;
    /**
     * @private
     * @type {import("../size.js").Size}
     */

    _this.size_ = options.size !== undefined ? options.size : null;
    return _this;
  }
  /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   */


  Icon.prototype.clone = function () {
    var scale = this.getScale();
    return new Icon({
      anchor: this.anchor_.slice(),
      anchorOrigin: this.anchorOrigin_,
      anchorXUnits: this.anchorXUnits_,
      anchorYUnits: this.anchorYUnits_,
      color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
      crossOrigin: this.crossOrigin_,
      imgSize: this.imgSize_,
      offset: this.offset_.slice(),
      offsetOrigin: this.offsetOrigin_,
      opacity: this.getOpacity(),
      rotateWithView: this.getRotateWithView(),
      rotation: this.getRotation(),
      scale: Array.isArray(scale) ? scale.slice() : scale,
      size: this.size_ !== null ? this.size_.slice() : undefined,
      src: this.getSrc()
    });
  };
  /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   */


  Icon.prototype.getAnchor = function () {
    var anchor = this.normalizedAnchor_;

    if (!anchor) {
      anchor = this.anchor_;
      var size = this.getSize();

      if (this.anchorXUnits_ == _IconAnchorUnits["default"].FRACTION || this.anchorYUnits_ == _IconAnchorUnits["default"].FRACTION) {
        if (!size) {
          return null;
        }

        anchor = this.anchor_.slice();

        if (this.anchorXUnits_ == _IconAnchorUnits["default"].FRACTION) {
          anchor[0] *= size[0];
        }

        if (this.anchorYUnits_ == _IconAnchorUnits["default"].FRACTION) {
          anchor[1] *= size[1];
        }
      }

      if (this.anchorOrigin_ != _IconOrigin["default"].TOP_LEFT) {
        if (!size) {
          return null;
        }

        if (anchor === this.anchor_) {
          anchor = this.anchor_.slice();
        }

        if (this.anchorOrigin_ == _IconOrigin["default"].TOP_RIGHT || this.anchorOrigin_ == _IconOrigin["default"].BOTTOM_RIGHT) {
          anchor[0] = -anchor[0] + size[0];
        }

        if (this.anchorOrigin_ == _IconOrigin["default"].BOTTOM_LEFT || this.anchorOrigin_ == _IconOrigin["default"].BOTTOM_RIGHT) {
          anchor[1] = -anchor[1] + size[1];
        }
      }

      this.normalizedAnchor_ = anchor;
    }

    var displacement = this.getDisplacement();
    return [anchor[0] - displacement[0], anchor[1] + displacement[1]];
  };
  /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */


  Icon.prototype.setAnchor = function (anchor) {
    this.anchor_ = anchor;
    this.normalizedAnchor_ = null;
  };
  /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */


  Icon.prototype.getColor = function () {
    return this.color_;
  };
  /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement} Image or Canvas element.
   * @api
   */


  Icon.prototype.getImage = function (pixelRatio) {
    return this.iconImage_.getImage(pixelRatio);
  };
  /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   */


  Icon.prototype.getPixelRatio = function (pixelRatio) {
    return this.iconImage_.getPixelRatio(pixelRatio);
  };
  /**
   * @return {import("../size.js").Size} Image size.
   */


  Icon.prototype.getImageSize = function () {
    return this.iconImage_.getSize();
  };
  /**
   * @return {import("../ImageState.js").default} Image state.
   */


  Icon.prototype.getImageState = function () {
    return this.iconImage_.getImageState();
  };
  /**
   * @return {HTMLImageElement|HTMLCanvasElement} Image element.
   */


  Icon.prototype.getHitDetectionImage = function () {
    return this.iconImage_.getHitDetectionImage();
  };
  /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   */


  Icon.prototype.getOrigin = function () {
    if (this.origin_) {
      return this.origin_;
    }

    var offset = this.offset_;

    if (this.offsetOrigin_ != _IconOrigin["default"].TOP_LEFT) {
      var size = this.getSize();
      var iconImageSize = this.iconImage_.getSize();

      if (!size || !iconImageSize) {
        return null;
      }

      offset = offset.slice();

      if (this.offsetOrigin_ == _IconOrigin["default"].TOP_RIGHT || this.offsetOrigin_ == _IconOrigin["default"].BOTTOM_RIGHT) {
        offset[0] = iconImageSize[0] - size[0] - offset[0];
      }

      if (this.offsetOrigin_ == _IconOrigin["default"].BOTTOM_LEFT || this.offsetOrigin_ == _IconOrigin["default"].BOTTOM_RIGHT) {
        offset[1] = iconImageSize[1] - size[1] - offset[1];
      }
    }

    this.origin_ = offset;
    return this.origin_;
  };
  /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */


  Icon.prototype.getSrc = function () {
    return this.iconImage_.getSrc();
  };
  /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   */


  Icon.prototype.getSize = function () {
    return !this.size_ ? this.iconImage_.getSize() : this.size_;
  };
  /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */


  Icon.prototype.listenImageChange = function (listener) {
    this.iconImage_.addEventListener(_EventType["default"].CHANGE, listener);
  };
  /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   */


  Icon.prototype.load = function () {
    this.iconImage_.load();
  };
  /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */


  Icon.prototype.unlistenImageChange = function (listener) {
    this.iconImage_.removeEventListener(_EventType["default"].CHANGE, listener);
  };

  return Icon;
}(_Image["default"]);

var _default = Icon;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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